import { COLOR_VALUES } from "shared/config/colors";
import { Col } from "react-bootstrap";
import HStack from "shared/components/layout/stack/HStack";
import { TEXT_VARIANT_STYLES } from "shared/components/data-display/text/Text";
import Text from "shared/components/data-display/mui/Text";
import VStack from "shared/components/layout/stack/VStack";
import styled from "styled-components";

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: calc(100vh - 40px);
`;

export const Container = styled.div`
    text-align: left;
    overflow-y: auto;
    overflow-x: hidden;
    padding: ${globalThis.config.sizes.sidebar.gutter};
    flex: 1;

    ::-webkit-scrollbar-thumb {
        background-color: #fff;
    }
    :hover {
        ::-webkit-scrollbar-thumb {
            background-color: #dde1e5;
        }
    }
`;

export const Title = styled.div`
    margin: 0.5em 0;
`;

export const TitleColumn = styled(Col)`
    padding-right: 0;
`;

export const Subtitle = styled.div`
    margin: 0.5em 0 2.5em 0;
`;

export const Section = styled.div`
    margin: 1em 0 0.5em 0;
`;

export const Footer = styled.div`
    padding: ${globalThis.config.sizes.sidebar.gutter};
    padding-top: 40px;
    padding-bottom: 24px;
    text-align: center;

    > * {
        margin-bottom: 0.5rem;
    }
`;

export const ButtonLink = styled.a`
    p {
        text-decoration: none;
    }
    &:hover {
        text-decoration: none;
    }
    button {
        width: 100%;
        margin-bottom: 0.5rem;
    }
    margin-bottom: 0.5rem;
`;

export const TextLink = styled.a`
    color: ${globalThis.config.colors.black};
    text-decoration: underline;
    display: block;
    &:hover {
        color: ${globalThis.config.colors.black};
    }
`;

export const MoreMenuContainer = styled.div`
    padding-top: 0.25rem;
`;

export const StyledWrapper = styled(HStack)`
    justify-content: space-between;
    padding: 0;
    gap: 24px;
`;

export const StyledSowContent = styled(VStack)`
    padding: 0;
    gap: 4px;
`;

export const StyledSowUpdatedDate = styled(VStack)`
    color: ${COLOR_VALUES.Gray_4};
    ${TEXT_VARIANT_STYLES.Descriptive_2_1};
    padding: 0;
    gap: 4px;
    white-space: nowrap;
`;

export const StyledSowStatusLabel = styled(Text)`
    margin-bottom: 4px;
`;

